import { render } from "./recycling.svg?vue&type=template&id=b2558996?inline"
const script = {}
script.render = render

export default script